<div class="dialog-layout">

    <h1 class="dialog-title">Encuesta</h1>

    <div class="encuesta-content">
        <div *ngFor="let encuesta of encuestas" class="encuesta-group">

            <div class="encuesta-pregunta">{{ encuesta.Pregusta }}</div>

            <table mat-table [dataSource]="encuesta.Respuestas" class="full-width-table">

                <ng-container matColumnDef="texto">
                    <th mat-header-cell *matHeaderCellDef class="col-texto">Opción</th>
                    <td mat-cell *matCellDef="let respuesta" class="col-texto">{{ respuesta.Texto }}</td>
                </ng-container>

                <ng-container matColumnDef="respuesta">
                    <th mat-header-cell *matHeaderCellDef class="col-check">Seleccionar</th>
                    <td mat-cell *matCellDef="let respuesta">
                        <mat-checkbox [checked]="getRespuesta(respuesta.Id)" (change)="setRespuesta(respuesta.Id, $event.checked)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['texto', 'respuesta']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['texto', 'respuesta'];"></tr>

            </table>

        </div>
    </div>

    <div class="dialog-actions">
        <button mat-raised-button color="primary" type="button" (click)="aceptar()" [disabled]="!puedeAceptar()">Aceptar</button>
    </div>

</div>
